import { required, email, minLength, minValue } from 'vuelidate/lib/validators';

export default {
  assignee: {
    id: { required }
  },
  shipper: {
    firstName: { required },
    phone: { required },
    email: { email }
  },
  origin: {
    state: { required },
    city: { required },
    zipcode: {
      required,
      valid: (value) => /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)
    }
  },
  destination: {
    state: { required },
    city: { required },
    zipcode: {
      required,
      valid: (value) => /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)
    }
  },
  vehicles: {
    required,
    minLength: minLength(1),
    $each: {
      year: { required },
      make: { required },
      model: { required },
      operable: { required }
    }
  },
  transport: {
    availableDate: { required },
    basePrice: { required },
    deposit: { required },
    totalPrice: { minValue: minValue(0), required }
  }
};
